var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footbowl"},[(_vm.footbowlGame)?_c('FootbowlDisplay',{attrs:{"states":(_vm.footbowlGame.states || [])
      .slice(0)
      .sort(function (a, b) { return a.sequenceNumber - b.sequenceNumber; }),"replayStates":_vm.isReplayGame},on:{"nextGame":_vm.onNextGame}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }